import { Component, OnInit } from '@angular/core';
import { ExpenseService } from '@app/core';
import { Expense } from '@core/model/expense.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CreateClientComponent } from '@app/dashboard/client/create-cliente/create-cliente.component';
import { ExpenseCreateComponent } from '@app/dashboard/expense/expense-create/expense-create.component';
import { Paginated } from '@app/core/model/paginated.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css']
})
export class ExpenseListComponent implements OnInit {
  expenses: Expense[];
  modalOption: NgbModalOptions;

  pager = {};
  pageOfItems: any = [];

  gastos: Paginated;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;

  constructor(
    public expenseService: ExpenseService,
    private modalService: NgbModal
  ) {
    this.modalOption = {
      size: 'lg',
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };
  }

  ngOnInit() {
    // this.ListExpense();

    this.expenseService.getGastos().then(gastos => (this.gastos = gastos));

    this.searchTermStream.subscribe((term: string) => {
      this.expenseService.search(term).then((gastos: any) => {
        this.currentSearchTerm = term;
        this.updateGastos(gastos);
      });
    });
  }

  updateGastos(gastos: Paginated) {
    const gastosWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      gastos
    );
    this.gastos = gastosWithUpdatedNavs;
    // const total =reduce((accum, curr) => accum + curr.goals, 0);
  }

  updateNavUrls(term: string, gastos: Paginated): Paginated {
    if (term) {
      if (gastos.prev_page_url) {
        gastos.prev_page_url += `&term=${term}`;
      }
      if (gastos.next_page_url) {
        gastos.next_page_url += `&term=${term}`;
      }
    }
    return gastos;
  }

  prevPage() {
    this.expenseService
      .getGastosAtUrl(this.gastos.prev_page_url)
      .then((productos: any) => {
        this.updateGastos(productos);
      });
  }

  nextPage() {
    this.expenseService
      .getGastosAtUrl(this.gastos.next_page_url)
      .then((productos: any) => {
        this.updateGastos(productos);
      });
  }

  search(term: string) {
    this.searchTermStream.next(term);
  }

  ListExpense() {
    this.expenseService.getAll().subscribe(
      data => {
        console.log(data);
        this.expenses = data;
      },
      error1 => console.log(error1)
    );
  }

  editModal(id: string) {
    const modal = this.modalService.open(
      ExpenseCreateComponent,
      this.modalOption
    );
    modal.componentInstance.expense_id = id;
    modal.componentInstance.title = 'Editar Gastos';
    modal.componentInstance.estado = true;

    modal.result.then(result => {
      if (result) {
        this.expenseService.getGastos().then(gastos => (this.gastos = gastos));
        this.searchTermStream.subscribe((term: string) => {
          this.expenseService.search(term).then((gastos: any) => {
            this.currentSearchTerm = term;
            this.updateGastos(gastos);
          });
        });
      }
    });
  }

  createExpense() {
    const modal = this.modalService.open(
      ExpenseCreateComponent,
      this.modalOption
    );
    modal.componentInstance.title = 'Crear gastos';
    modal.result.then(result => {
      if (result) {
        this.expenseService.getGastos().then(gastos => (this.gastos = gastos));
        this.searchTermStream.subscribe((term: string) => {
          this.expenseService.search(term).then((gastos: any) => {
            this.currentSearchTerm = term;
            this.updateGastos(gastos);
          });
        });
      }
    });
  }
}
